import { render, staticRenderFns } from "./iosmember.vue?vue&type=template&id=7aa4af08&scoped=true"
import script from "./iosmember.vue?vue&type=script&lang=js"
export * from "./iosmember.vue?vue&type=script&lang=js"
import style0 from "./iosmember.vue?vue&type=style&index=0&id=7aa4af08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa4af08",
  null
  
)

export default component.exports